import s from './partner.module.scss'

const partners = [
  {
    logo: '/assets/axie-game-jam/playroom.svg',
    title: 'Playroom'
  },
  {
    logo: '/assets/axie-game-jam/colyseus.png',
    title: 'Colyseus'
  }
]

export const Partner = () => {
  return (
    <div className={s.container}>
      <h3 className={s.title}>Partners of honor</h3>
      <div className={s.partners}>
        {partners.map((partner, index) => (
          <div className={s.partner} key={index}>
            <img src={partner.logo} alt={partner.title} title={partner.title} />
          </div>
        ))}
      </div>
    </div>
  )
}
